import React from 'react';
import { connect } from 'react-redux';
import SaveRoleDialog from './SaveRoleDialog';
import ConfirmPermissionsDialog from './ConfirmPermissionsDialog';
import RoleReassignDialog from './RoleReassignDialog';
import EditRoleActionsDialog from '../roleactions/containers/EditRoleActionsDialog';
import RoleDefaultRoleDialog from './RoleDefaultRoleDialog';

const RoleDialogs = ({
  allowCreate,
  allowEdit,
  allowEditActions,
  allowReassign,
  allowConfigure,
  theme,
}) => (
  <>
    {allowConfigure && <RoleDefaultRoleDialog theme={theme} />}
    {allowCreate && <SaveRoleDialog theme={theme} />}
    {allowEdit && <ConfirmPermissionsDialog theme={theme} />}
    {allowEditActions && <EditRoleActionsDialog theme={theme} />}
    {allowReassign && <RoleReassignDialog theme={theme} />}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { roles, configurations } } },
  roles: { roles: { defaultSelection, reassign }, activeRole, activeRoleActions },
}) => ({
  allowConfigure: defaultSelection.open && configurations.update,
  allowCreate: activeRole.open && roles.create,
  allowEdit: activeRole.confirmChangesOpen && roles.update,
  allowEditActions: activeRoleActions.open && roles.update,
  allowReassign: reassign.open && roles.assign,
});

export default connect(mapStateToProps)(RoleDialogs);
